<!--
Author: TangChen
Date: 2018-09-17
Desc: 用户信息展示组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-acct-info bizcomp ' + className">
        <comp-title :title="title" />
        <el-row class="accountInfo">
            <el-col :span="8" class="circle-bg">
                <div class="act-info clear">
                    <div class="act-img">
                        <img v-if="info.headimage" :src="info.headimage">
                        <img v-else :src="require('../../assets/img/account-img.png')">
                        <span class="img-btn">编辑</span>
                        <el-input
                            v-model="headimage"
                            type="file"
                            name="headimage"
                            :accept="accept"
                            v-on:change="getImgBase"
                            placeholder="编辑"
                        />
                    </div>
                    <div class="act-basic">
                        <div class="user-info">
                            <p class="name">
                                <span
                                    class="k-text-flow"
                                    :class="{'mobilet':!info.custname}"
                                    :title="info.custname?info.custname:info.mobile"
                                >{{ info.custname?info.custname:(info.mobile?info.mobile:info.certificateno) }}<span
                                    class="like-a"
                                    v-on:click="$router.push({name:'modifyinfo'})"
                                >[编辑个人信息]</span></span>
                            </p>
                        </div>
                        <div class="investor">
                            <p v-if="info.lastlogintime && info.lastlogintime!=='0'" class="login-time">
                                上次登录时间：<span> {{ info.lastlogintime }}</span>
                            </p>
                            <p v-if="!info.lastlogintime||info.lastlogintime==='0'" class="login-time">
                                投资者类型：<span> {{ (info.professionflag?$cache.getDict('120051', info.professionflag):'未知')+(info.professionflag==='1'&&info.professionexpired==='1'?'(已过期)':'') }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="16" class="user-info-icon">
                <el-col v-if="info.professionflag!=='1'||info.professionexpired==='1'" :span="8">
                    <span class="icon-img" />
                    <div class="icon-info">
                        <span class="amount">风险类型</span>
                        <span class="amount-info">{{ info.custrisk?$cache.getDict('100017',info.custrisk):'未做风险评测' }}<span v-if="info.custrisk" class="like-a" v-on:click="$router.push({name:'risk'})">[重新测评]</span><span v-if="!info.custrisk" class="like-a" v-on:click="$router.push({name:'risktest'})">[立即评测]</span></span>
                    </div>
                </el-col>
                <el-col :span="8">
                    <span class="icon-img mobile" />
                    <div class="icon-info">
                        <span class="amount">手机</span>
                        <span class="amount-info">
                            {{ info.mobile.length === 11?info.mobile:'没有绑定手机号' }}
                            <span v-if="info.usertype!=='2'&&info.usertype!=='1'" class="like-a" v-on:click="$router.push({name:$util.isEmpty(info.mobile)?'bindmobile':'checkmobile'})">{{ '['+(!$util.isEmpty(info.mobile)?'修改':'绑定')+']' }}</span>
                        </span>
                    </div>
                </el-col>
                <el-col :span="8">
                    <span class="icon-img safe" />
                    <div class="icon-info">
                        <span class="amount">安全中心</span>
                        <span class="amount-info"><span v-if="info.mobile.length === 11" class="like-a" v-on:click="info.usertype !== '2' ? $router.push({name:'changelpwd'}) : $router.push({name:'changeqpwd'})">{{ info.usertype !== '2' ? '[登录密码]' : '[查询密码]' }}</span><span v-if="!$util.isEmpty(info.certificatetype)&&info.mobile.length === 11">/</span><span v-if="!$util.isEmpty(info.certificatetype)" class="like-a" v-on:click="$router.push({name:'changetpwd'})">[交易密码]</span></span>
                    </div>
                </el-col>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "AcctInfo",
    mixins: [mixin],
    data () {
        return {
            headimage: "",
            base64Img: "",
            info: {},
            accept: "image/bmp,image/png,image/jpg,image/jpeg"
        };
    },
    created () {
        const _this = this;
        this.info = this.$cache.getUser();
        this.$util.getProfession(data=>{
            _this.info = Object.assign({}, _this.info,data);
        });
    },
    methods: {
        getImgBase () {
            const _this = this;
            const event = window.event;
            const file = event.target && event.target.files[0];
            if (!file) {
                this.delImg(event.target.name);
                return false;
            }
            let maxSize = "3";
            if (file.size > 1024 * 1024 * maxSize) {
                this.headimage = "";
                this.$message.warning("上传文件大小超过限制大小" + maxSize + "M，不能上传");
                return;
            }
            const reader = new FileReader();
            // 转base64
            reader.onload = function (e) {
                _this.base64Img = e.target.result;
                _this.upHeaderImg();
            };
            reader.readAsDataURL(file);
        },
        upHeaderImg () {
            let _this = this;
            let oParam = {
                headimage: this.base64Img
            };
            this.$util.request("acct/headimage", oParam, "POST").then(res => {
                if (res.data) {
                    const info = _this.$cache.getUser();
                    info.headimage = _this.base64Img;
                    _this.$store.dispatch("setInfo", info);
                    _this.info.headimage = _this.base64Img;
                }
            });
        },
        upImg () {
            this.$refs.upImg.click();
        }
    }
};
</script>
<style lang="scss">
  @import '../../assets/css/varibles';
  /* 用户信息 */
  .bizcomp-acct-info {
    .accountInfo {
      .act-info {
        padding: 19px 0;
        .act-img {
          position: relative;
          margin-left: 16px;
          width: 80px;
          height: 80px;
          float: left;
          border-radius: 100% 100%;
          -webkit-border-radius: 100% 100%;
          overflow: hidden;
          img {
            width: 80px;
            height: 80px;
          }
          .img-btn {
            position: absolute;
            bottom: 0px;
            line-height: 24px;
            z-index: 100;
            width: 100%;
            left: 0;
            cursor: pointer;
            text-align: center;
            color: $text-color6;
            font-size: $f12;
            background-color: rgba(0, 0, 0, 0.3);
            display: none;
          }
          &:hover .img-btn {
            display: block;
          }
            .el-input {
                position: absolute;
                bottom: 0px;
                right: 0px;
                z-index: 101;
                opacity: 0;
            }
        }
        .act-basic {
          float: left;
          color: $text-color2;
          line-height: 24px;
          padding-left: 20px;
          p {
            display: inline-block;
            vertical-align: middle;
          }
          .investor {
            line-height: 24px;
            color: $text-color1;
            span {
              vertical-align: middle;
              color: $text-color2;
            }
          }
          .user-info {
            line-height: 40px;
            .name .k-text-flow {
              font-size: $f24;
              display: inline-block;
              vertical-align: middle;
              .like-a {
                font-size: $f14;
                width: auto;
                margin-left: 10px;
              }
              &.mobilet {
                font-size: $f18;
              }
            }
          }
        }
      }
      .user-info-icon {
        padding: 30px 10px 0 30px;
        .icon-img {
          width: 54px;
          height: 54px;
          border-radius: 100%;
          background: $bg1 url($investor) -207px 0px no-repeat;
          &.mobile {
            background-position-x: -258px;
          }
          &.safe {
            background-position-x: -304px;
          }
        }
        .icon-info,
        .icon-img {
          display: inline-block;
          vertical-align: middle;
        }
        .icon-info {
          margin-left: 16px;
          .amount {
            display: block;
            color: $text-color2;
            line-height: 26px;
            font-size: $f18;
          }
          .amount-info {
            color: $text-color3;
            line-height: 26px;
            .like-a:first-of-type{margin-left: 5px;}
          }
        }
      }
    }
  }
</style>
